import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import '../subscription.scss';
import { Button, Icons } from '../../../../components/base/BootstrapComponents';
import { getSubscriptionData } from '../../reducer';
import {
  deleteBlackWhites,
  loadCurrentBlackWhitesById,
  loadCurrentBlackWhitesByIdClear,
  loadBlackList,
} from '../../actions';
import PageHeader from '../../../../components/base/PageHeader/PageHeader';
import {
  responseLogWithNotification,
  getPaginationOpts,
  getJsonFromStorage,
  useUpdatePeriod,
} from '../../../../utils/utils';
import Loader from '../../../../components/base/Loader/Loader';
import { getSystemData } from '../../../System/reducer';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import { blackWhitesColumns } from '../../constants';
import Pagination from '../../../../components/base/Pagination/Pagination';
import TooltipWithPortal from '../../../../components/base/Tooltip/TooltipWithPortal';
import { showGlobalConfirm } from '../../../System/actions';
import notificationDecorator from '../../../Notifications/notificationDecorator';
import IconBox from '../../../../components/common/IconBox';
import BlackWhiteDialog from './BlackWhiteDialog';

export default function BlackListPage() {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const {
    blackList,
    blackListMeta,
    loadingBlackList,
    loadingCurrentBlackWhites,
    loadingCreateBlackWhites,
    loadingEditBlackWhites,
    loadingDeleteBlackWhites,
    blackWhitesModuleAvailable,
    blackWhitesModuleChecked,
  } = useSelector(getSubscriptionData);

  const { updatePeriod } = useSelector(getSystemData);

  const initial = getJsonFromStorage('black-list-filter', {});
  const { getValues, watch } = useForm({ defaultValues: { ...initial } });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(blackListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };
    const p1 = dispatch(loadBlackList(requestData)).catch(() => {});
    return Promise.all([p1]);
  };

  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  useEffect(() => {
    const subscriptionType = watch(() => { loadData(); });
    return () => subscriptionType.unsubscribe();
  }, [watch]);

  const handleCreate = () => {
    setShowForm(true);
  };

  const handleEdit = item => e => {
    dispatch(loadCurrentBlackWhitesById(item.id))
      .then(() => {
        setShowForm(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDelete = item => e => {
    dispatch(showGlobalConfirm({
      confirmTitle: 'Удаление ГРЗ',
      confirmMessage: `Вы уверены, что хотите удалить ГРЗ ${item.lpn}?`,
      confirmButtonText: 'Удалить',
    })).then(() => {
      dispatch(deleteBlackWhites(item.id))
        .then(() => {
          loadData();
          notificationDecorator({
            title: 'Удаление ГРЗ',
            message: 'Успешно',
          });
        })
        .catch(responseLogWithNotification);
    }).catch(() => {});
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = () => {
    dispatch(loadCurrentBlackWhitesByIdClear());
    setShowForm(false);
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
            Редактировать
          </Button>
          <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}>
            Удалить
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const isModuleUnavailable = blackWhitesModuleChecked && !blackWhitesModuleAvailable;

  return (
    <div className="subscription-tab">
      <Loader global loading={loadingCurrentBlackWhites || loadingCreateBlackWhites || loadingEditBlackWhites || loadingDeleteBlackWhites || loadingBlackList} />
      <div className="page-container">
        <div className="inputs-box">
          <PageHeader header="Черный список" />
          <div className="inputs">
            {!isModuleUnavailable ? <IconBox icon="plus-add" onClick={handleCreate} /> : null}
          </div>
        </div>
        {isModuleUnavailable ? (
          <div className="subscription-module-unavailable">
            <div className="subscription-module-unavailable-title">Модуль недоступен</div>
            <div className="subscription-module-unavailable-description">Нет подключения к сервису черного/белого списка.</div>
          </div>
        ) : (
          <div className="plp-table g-0">
            <div className="frame">
              <div className="sticky-table-wrapper custom-scroll-theme">
                <CustomizedGrid
                  className="plp-grid"
                  data={blackList}
                  columns={blackWhitesColumns}
                  name="black-list"
                  settingsFormatter={moreFormatter}
                />
              </div>
            </div>
            <Pagination meta={blackListMeta} list={blackList} handleChangeMeta={loadData} />
          </div>
        )}
      </div>
      {showForm ? <BlackWhiteDialog handleClose={handleClose} loadData={loadData} type="BLACK" /> : null}
    </div>
  );
}
